import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// Initial state
const initialState = {
  loading: null,
  loaded: null,
  error: null,
  data: null,
  maskedPhoneNumber: null,
};

// Slice
const maskedPhoneNumberSlice = createSlice({
  name: "maskedPhoneNumber",
  initialState,
  reducers: {
    initPhoneNumber(state) {
      return {
        ...state,
        loading: null,
        loaded: null,
        error: null,
        data: null,
        maskedPhoneNumber: null,
      };
    },
    getMaskedPhoneNumber(state) {
      return { ...state, loading: true, error: false };
    },
    setMaskedPhoneNumber(state, action) {
      const { maskedPhoneNumber } = action.payload;
      return { ...state, maskedPhoneNumber: maskedPhoneNumber };
    },
    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
  },
});

export const {
  initPhoneNumber,
  getMaskedPhoneNumber,
  setMaskedPhoneNumber,
  fetchDataSuccess,
  fetchDataFailure,
} = maskedPhoneNumberSlice.actions;

export default maskedPhoneNumberSlice.reducer;

//saga
function* fetchDataSaga(action) {
  const peerIp = yield select((state) => state.peerIp.ip);
  try {
    const { headers = {}, apiUrl, data } = action.payload;
    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      }
    });
    const response = yield call(apiService.get, apiUrl, data);

    if (response?.data) {
      const { result_code, result_data } = response.data;
      if (result_code === "20000") {
        console.log(result_data)
        yield put(setMaskedPhoneNumber({ maskedPhoneNumber: result_data }));
      }
    }
    yield put(fetchDataSuccess(response.data));
  } catch (error) {
    yield put(fetchDataFailure(error));
  }
}

// API 호출을 감시하는 Saga 함수
export function* maskedPhoneNumberSaga() {
  yield takeLatest(getMaskedPhoneNumber.type, fetchDataSaga);
}
